const typographyCalendar = {
  clearFilterButton: 'Limpiar'
};

export default typographyCalendar;
